enum TransactionStatus {
  OPEN = 'Pending',
  APPROVED = 'Accepted',
  REJECTED = 'Rejected',
}

export default TransactionStatus;
